<app-crud-edit *ngIf="inited" [form]="form" (save)="save()"></app-crud-edit>
